import React from "react";
import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { Experience } from "@/components/sections/Experience";
import { Highlights } from "@/components/sections/Highlights";
import { Gallery } from "@/components/sections/Gallery";
import { Testimonials } from "@/components/sections/Testimonials";
import { Booking } from "@/components/sections/Booking";

const Home = () => (
  <main>
    <Hero />
    <About />
    <Experience />
    <Highlights />
    <Gallery />
    <Testimonials />
    <Booking />
  </main>
);

export default Home;
